/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
// import {useIntl} from 'react-intl'
// import {KTIcon} from '../../../../helpers'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../app/redux/store'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { userBiz } from '../../../../../app/biz/userBiz'
import { IconExternalLink } from '../../../../../app/assets/image/icon'

type Props = {

}

const SidebarMenuMain: React.FC<Props> = () => {
  const agentSlice = useSelector((state: RootState) => state.agent)

  const redirectToNextsixAgent = async () => {
    const res = await userBiz.createNextsixAgentLink(agentSlice._id);
    window.open(res.authenticatedLink, '_blank');
  }

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        title='Dashboard'
        path='dashboard'
      />

      <SidebarMenuItemWithSub
        to='/my-folder'
        title='My Folder'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItem
          to='/my-folder/analytic'
          title='My PA'
          path='analytic'
        />
        <SidebarMenuItem
          to='my-folder/payment-voucher'
          title='My Payment Voucher'
          path='payment-voucher'
        />
        <SidebarMenuItem
          to='my-folder/profile'
          title='My profile'
          path='profile'
        />
        <SidebarMenuItem
          to='my-folder/cp58-listing'
          title='My CP58 Listing'
          path='cp58-listing'
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItem
        to='/memo'
        title='Memo Listing'
        path='memo'
      />

      <SidebarMenuItem
        to='/company-letter'
        title='Company Letter'
        path='company-letter'
      />

      <SidebarMenuItemWithSub
        to='/employment-application'
        title='Employment Application'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItem
          to='/employment-application/employment-listing'
          title='Employment Application'
          path='employment-application'
        />
        <SidebarMenuItem
          to='/employment-application/attachment-listing'
          title='Employment Application Attachment'
          path='employment-application-attachment'
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='purchase-form'
        title='Purchase Form'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItem
          to='purchase-form/secure-purchase-form'
          title='Secure Purchase Form'
          path='secure-purchase-form'
        />
        <SidebarMenuItem
          to='purchase-form/purchase-cum-receipt-form'
          title='Purchase Cum Receipt Form'
          path='purchase-cum-receipt-form'
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='rent-form'
        title='Rent Form'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItem
          to='rent-form/secure-rent-form'
          title='Secure Rent Form'
          path='secure-rent-form'
        />
        <SidebarMenuItem
          to='rent-form/rent-cum-receipt-form'
          title='Rent Cum Receipt Form'
          path='rent-cum-receipt-form'
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItem
        to='developer-sale-form'
        title='Developer Sale Form'
        path='developer-sale-form'
      />

      <SidebarMenuItem
        to='claim-submission-form'
        title='Claim Submission Form'
        path='claim-submission-form'
      />

      <SidebarMenuItemWithSub
        to='official-receipt'
        title='Official Receipt'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItem
          to='official-receipt/request-listing'
          title='Official Receipt Request'
          path='official-receipt-request-listing'
        />
        <SidebarMenuItem
          to='official-receipt/request-history'
          title='Official Receipt Request History'
          path='official-receipt-request-history'
        />
        <SidebarMenuItem
          to='official-receipt/listing'
          title='Official Receipt'
          path='official-receipt-listing'
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='tax-invoice'
        title='Tax Invoice'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItem
          to='tax-invoice/request-listing'
          title='Tax Invoice Request'
          path='tax-invoice-request-listing'
        />
        <SidebarMenuItem
          to='tax-invoice/request-history'
          title='Tax Invoice Request History'
          path='tax-invoice-request-history'
        />
        <SidebarMenuItem
          to='tax-invoice/listing'
          title='Tax Invoice'
          path='tax-invoice-listing'
        />
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='nextsix-property'
        title='Nextsix Property'
        path='nextsix-property'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <div className='menu-item'>
          <span className="menu-link without-sub" onClick={redirectToNextsixAgent}>
            <div className='menu-select'></div>
            <span className='menu-icon'></span>
            <span className='menu-title externalLink'>TRR Agent Tool <IconExternalLink/></span>
          </span>
        </div>
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='my-store'
        title='My Store'
        path='my-store'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItem
          to='my-store/order-listing'
          title='Store Order Listing'
          path='store-order-listing'
        />
        <div className='menu-item'>
          <a className="menu-link without-sub" href={`http://buy.iproforma.com/home.html?agent=${agentSlice._id}`} target='_blank'>
            <div className='menu-select'></div>
            <span className='menu-icon'></span>
            <span className='menu-title'>Shop</span>
          </a>
        </div>
      </SidebarMenuItemWithSub>

      <SidebarMenuItemWithSub
        to='settings'
        title='Settings'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItem
          to='settings/change-password'
          title='Change Password'
          path='change-password'
        />
      </SidebarMenuItemWithSub>
    </>


    // <SidebarMenuItem
    // to='/'
    // title=''
    // path=''
    // />

    // <SidebarMenuItemWithSub
    // to=''
    // title=''
    // fontIcon='bi-archive'
    // icon='element-plus'
    // >
    //  <SidebarMenuItem
    //   to='/'
    //   title=''
    //   path=''
    // />
    // </SidebarMenuItemWithSub>
  )
}

export { SidebarMenuMain }
